import { cEl, setToken } from '../../../util';
import { InputGroup } from '../Contact/ContactForm';
import { login } from '../../../api/admin';
import { navigateTo } from '../../AppHeader/Link';
import { PATH_ADMIN_SUBMISSIONS } from '../../path';

function Login() {
    const loginContainer = cEl('div');
    loginContainer.classList.add('login-container');

    const loginFormContainer = cEl('form');
    loginFormContainer.classList.add('form-container');

    const submitWrapper = cEl('div');
    submitWrapper.classList.add('submit-wrapper');

    const submitButton = cEl('button');
    submitButton.classList.add('button', 'brand-button');
    submitButton.type = 'submit';
    submitButton.innerHTML = '확인';

    submitWrapper.appendChild(submitButton);

    loginFormContainer.addEventListener('submit', e => {
        e.preventDefault();
        const formData = new FormData(loginFormContainer);

        const param = Object.fromEntries(formData);

        login(param)
            .then(res => {
                if (res.data?.token && res.data.tokenType) {
                    const { token, tokenType } = res.data;
                    setToken(`${tokenType}${token}`);
                    navigateTo(PATH_ADMIN_SUBMISSIONS);
                } else if (res.code === '4011') {
                    password.classList.add('invalid');
                }
            })
            .catch(console.error);
    });

    const password = InputGroup({
        id: 'password',
        name: 'password',
        required: true,
        label: '관리자 비밀번호',
        inputType: 'password',
        placeholder: '비밀번호를 입력해주세요.',
    });

    password.querySelector('input').addEventListener('input', e => {
        password.classList.remove('invalid');
    });

    const errMsg = cEl('div');
    errMsg.classList.add('err-msg');
    errMsg.innerHTML = '비밀번호가 올바르지 않습니다.';
    password.append(errMsg);

    loginFormContainer.append(password, submitWrapper);

    loginContainer.append(loginFormContainer);

    return loginContainer;
}

export default Login;
